






























import Vue from 'vue'
import '../codemirror-global.js'
import CodeMirror, { EditorConfiguration } from 'codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/monokai.css'
import 'codemirror/mode/clike/clike.js'
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/addon/hint/javascript-hint.js'
import 'codemirror/addon/edit/closebrackets.js'
import 'codemirror/addon/comment/comment.js'
import { Language } from '@/models/language'
import { CodingRecorder } from '@/CodingRecorder'
import SaveVideoModal from '@/components/SaveVideoModal.vue'
import { SaveVideoUserEditData } from '@/models/SaveVideoUserEditData.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCircle, faStop } from '@fortawesome/free-solid-svg-icons'

library.add(faCircle, faStop)

type DataType = {
  editor?: CodeMirror.EditorFromTextArea
  recorder: CodingRecorder
  defualtConfig: EditorConfig
  languages: Language[]
  selectedLanguage: Language
}
interface EditorConfig extends EditorConfiguration {
  autoCloseBrackets: boolean
}
export default Vue.extend({
  name: 'EditorPage',
  components: {
    SaveVideoModal,
    FontAwesomeIcon,
  },
  data(): DataType {
    return {
      defualtConfig: {
        lineNumbers: true,
        indentUnit: 4,
        theme: 'monokai',
        autoCloseBrackets: true,
        showHint: true,
        extraKeys: {
          'Ctrl-Space': 'autocomplete',
          'Ctrl-/': (e: CodeMirror.Editor) => e.toggleComment(),
        },
      },
      recorder: new CodingRecorder(),
      languages: [
        {
          tag: 'javascript',
          name: 'JavaScript',
        },
        {
          tag: 'text/x-csrc',
          name: 'C言語',
        },
        {
          tag: 'text/x-c++src',
          name: 'C++',
        },
        {
          tag: 'text/x-java',
          name: 'Java',
        },
      ],
      selectedLanguage: {
        tag: 'text/x-csrc',
        name: 'C言語',
      },
    }
  },
  methods: {
    setEditorSize: function () {
      const sidePanelWidth = 300
      const bottomPanelHeight = 200
      let width = document.body.clientWidth - sidePanelWidth
      let height = document.body.clientHeight - bottomPanelHeight
      width = width >= 0 ? width : 0
      height = height >= 0 ? height : 0
      console.log('resize w :' + width + 'h:' + height)
      this.editor?.setSize(width, height)
    },
    recordStart: function () {
      this.recorder.start(this.editor)
    },
    recordStop: function () {
      this.recorder.stop()
      this.$modal.show('save-video-modal')
    },
    recordSave: function (data: SaveVideoUserEditData): void {
      const video = this.recorder.outputVideo(
        -1,
        data.name,
        data.title,
        this.selectedLanguage,
        data.comment
      )
      var url = (window.URL || window.webkitURL).createObjectURL(
        new Blob([JSON.stringify(video)], { type: 'application/json' })
      )
      const a = document.createElement('a')
      a.href = url
      a.download = `${data.name}_${data.title}_video.json`
      a.click()
    },
    recordCancel: function (): void {
      this.recorder.clearVideo()
    },
  },
  watch: {
    selectedLanguage: function (newLang: Language) {
      this.editor?.setOption('mode', newLang.tag)
    },
  },
  mounted() {
    const editorAria: HTMLTextAreaElement | null =
      document.querySelector('#editor-aria')
    if (editorAria == null) {
      throw new Error('textarea not found for CodeMirror')
    }
    const config = this.defualtConfig
    this.editor = CodeMirror.fromTextArea(editorAria, config)
    this.setEditorSize()
    this.editor.setOption('mode', this.selectedLanguage.tag)
    this.recorder.register(this.editor)
    window.onresize = this.setEditorSize
  },
  beforeDestroy() {
    this.recorder.unregister(this.editor)
    window.onresize = null
  },
})
